import { isReactNative, isWeapp, isWeb } from 'yofobasement/utils/runtime';

export default {
  openURL: (url) => {
    if (isReactNative()) {
      return require('react-native').Linking.openURL(url);
    }
    if (isWeapp()) {
      wx.makePhoneCall({
        phoneNumber: url // 需要拨打的电话号码
      });
    }
    if (isWeb()) {
      window.location.href = url;
    }
  },
  openSettings: () => {
    if (isReactNative()) {
      return require('react-native').Linking.openSettings();
    }
  }
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/Linking.js